import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  The Biodiversity Conservation Strategy identifies 36 conservation areas of high biodiversity value for matters of
  national environmental significance and state significance.
    </p>
    <p>
  The boundaries of the conservation areas are set by a declaration under section 11 of the{' '}
  <InlineLink text="Melbourne Strategic Assessment (Environment Mitigation Levy) Act 2020" href="https://www.msa.vic.gov.au/__data/assets/pdf_file/0032/477662/Conservation-Areas-Declaration.pdf" mdxType="InlineLink" />
  .
    </p>
    <p>
  This tool identifies any area within a parcel designated as part of a conservation area. For more information about
  conservation areas, including how conservation areas are protected and managed, either refer to the{' '}
  <InlineLink text="Melbourne Strategic Assessment website" href="https://www.msa.vic.gov.au/" mdxType="InlineLink" /> or contact{' '}
  <InlineLink text="msa.conservation@delwp.vic.gov.au" href="mailto:msa.conservation@delwp.vic.gov.au" mdxType="InlineLink" />.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      